// extracted by mini-css-extract-plugin
export default {"data-room__icon-container":"style_data-room__icon-container__V4TO-","data-room__text":"style_data-room__text__PJlvV"};